import { ReactNode, useRef, useEffect } from 'react';
import { createPortal } from 'react-dom';
import CloseIcon from '@mui/icons-material/Close';

import { KEYS } from "~/const";
import { classNames } from "~/utils/utils";

import "./style.less";

interface IModal {
	children: ReactNode;
	className: string;
	onClose?: () => void;
}

export default function Modal({
	children = null,
	className = "",
	onClose = () => {},
} : IModal) {
	const modalRef = useRef<HTMLDivElement>(null);
	const classess = classNames([
		"modal-window",
		className || "",
	]);

	function handleEscape(event: KeyboardEvent) {
		if (event.key === KEYS.ESC) {
			onClose();
		}
	}

	useEffect(() => {
		document.addEventListener('keydown', handleEscape);

		return () => {
			document.removeEventListener('keydown', handleEscape);
		};
	}, []);

	return createPortal(
		<div className="modal" ref={modalRef}>
			<div className={classess}>
				<button type="button" onClick={() => onClose()} className="modal-window-btn-close">
					<CloseIcon className="MyCloseButton"/>
				</button>
				{children}
			</div>
		</div>,
		document.querySelector('#modal') || document.body,
	);
}
